module.exports = "<input type=\"text\" class=\"lpview_numeric_input numeric_input\" tabindex=\"1\">";